module.exports = __webpack_public_path__ + "img/note-yellow.02bc52f4.svg";